import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnDestroy, OnChanges} from '@angular/core';
import {LocalService} from '../../../_services/local.service';
import {AnagraficaBase} from '../../../_models/AnagraficaBase';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {SaveMessage} from '../../../_helpers/save-message';
import {Subscription} from 'rxjs';
import {Organizzazione} from '../../../_models/Organizzazione';

@Component({
    selector: 'app-select-terzisti',
    templateUrl: './select-terzisti.component.html',
    styleUrls: ['./select-terzisti.component.scss'],
    standalone: false
})
export class SelectTerzistiComponent  implements OnInit, OnDestroy, OnChanges {
  @Input() selectedTerzistaId = 0;
  @Input() gruppoDoc = '';
  @Input() codLav = '';
  @Input() terzista: AnagraficaBase;
  @Output() terzistaChange = new EventEmitter<AnagraficaBase>();
  @Input() groupDocOriginale = 0;
  terzisti: AnagraficaBase[] = [];
  isOpen = true;
  search = '';
  subscription: Subscription;
  loading = false;
  constructor(
    private organizzazioneService: OrganizzazioniService,
    private localService: LocalService,
    private saveMessage: SaveMessage) {
    this.subscription = this.organizzazioneService.currentOrganizzazioneSubject
      .subscribe((_org: Organizzazione) => this.getTerzistiOrdiniAperti());
    this.subscription.add(this.localService.searchText.subscribe(text => {
      this.search = text;
      if (!this.gruppoDoc) return false;
      this.getTerzistiOrdiniAperti();
    }));
  }

  ngOnInit() {
    this.getTerzistiOrdiniAperti();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gruppoDoc']) {
      this.getTerzistiOrdiniAperti();
    }
  }

  getTerzistiOrdiniAperti = () => {
    if (!this.gruppoDoc) return false;
    this.loading = true;
    this.terzisti = [];
    this.localService
      .getFornitoriOrdiniApertiAsync(this.organizzazioneService.organizzazioneId, this.gruppoDoc, this.groupDocOriginale, this.search)
      .then((_terzisti: SearchResult<AnagraficaBase>) => {
        if (_terzisti.totalCount > 0) {
          this.isOpen = true;
          this.terzisti = _terzisti.result;
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei terzisti."))
      .finally(() => this.loading = false);
  };

  selectTerzista = (terzista: AnagraficaBase) => {
    if (!this.isOpen) {
      this.isOpen = true;
      return false;
    }
    this.isOpen = false;
    this.selectedTerzistaId = terzista.id;
    this.terzistaChange.emit(terzista);
  };

  openList = () => this.isOpen = !this.isOpen;
}
